import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type JmPay = {
  jm_pay_id?: number;
  user_id?: number;
  payment_information?: { [key: string]: Record<string, any> };
  type?: string;
  price?: number;
  created_at?: number;
  update_at?: number;
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] JmPay
   * --
   */
  getJmPays: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_JM_PAY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] JmPay
   * --
   */
  getJmPay: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_JM_PAY, { jm_pay_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] JmPay
   * --
   */
  createJmPay: async (body: JmPay) => {
    try {
      const res = await $http.post(APIConstant.CREATE_JM_PAY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] JmPay
   * --
   */
  updateJmPay: async (body: JmPay) => {
    try {
      const { jm_pay_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_JM_PAY, {
        jm_pay_id: jm_pay_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] JmPay
   * --
   */
  deleteJmPay: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_JM_PAY, {
        jm_pay_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] JmPay
   * --
   */
  autoChargeJmPay: async (body: JmPay) => {
    try {
      const res = await $http.post(APIConstant.AUTO_CHARGE_JM_PAY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] JmPay
   * --
   */
  manualChargeJmPay: async (body: JmPay) => {
    try {
      const res = await $http.post(APIConstant.MANUAL_CHARGE_JM_PAY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] JmPay
   * --
   */
  cancelChargeJmPay: async (body: JmPay) => {
    try {
      const res = await $http.post(APIConstant.CANCEL_CHARGE_JM_PAY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] JmPay
   * --
   */
  refundChargeJmPay: async (body: JmPay) => {
    try {
      const res = await $http.post(APIConstant.REFUND_CHARGE_JM_PAY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
